import { Component, Input } from '@angular/core';
import { BaseNewRequestControlName } from '../../shared/base-new-request-form/base-new-request-form.model';
import { MultiPersonDataComponent } from '../multi-person-data/multi-person-data.component';

@Component({
  selector: 'app-proxy-details',
  templateUrl: '../multi-person-data/multi-person-data.component.html',
  standalone: false,
})
export class ProxyDetailsComponent extends MultiPersonDataComponent {
  override controlName = {
    DetailsCheckbox: BaseNewRequestControlName.ProxyDetailsCheckbox,
    Details: BaseNewRequestControlName.ProxyDetails,
    DetailsArray: BaseNewRequestControlName.ProxyDetailsArray,
  };
  override multiple = false;
  override proxyTypeFormControlVisible = true;
  override addressFormGroupBasedOnSelectControls = true;
  override title = 'PROXY_DETAILS';
  override singleElementTitle = 'PROXY_DETAILS';
  override addButtonText = 'ADD_PROXY';
  override infoText = 'PROXY_DETAILS_INFO';
  override onlinePaymentInfoText = 'PROXY_DETAILS_INFO_ONLINE_PAYMENT';
  @Input() override isPeselVisible = true;
}
